export enum LiveClassStatus {
  Full = 'full',
  Scheduled = 'sch',
  Completed = 'com',
  Cancelled = 'can',
  GuaranteedToRun = 'con',
  Available = 'available',
  Delivered = 'dlv',
  OnHold = 'hld',
}

export enum LiveClassModality {
  VirtualTraining = 'vt',
  InstructorLedTraining = 'ilt',
  OnSite = 'os',
  OnSiteVirtualTraining = 'osvt',
}

export enum LiveClassTableStatus {
  Full = 'Full',
  Confirm = 'Guaranteed to run',
  Available = 'Available',
  Scheduled = 'Scheduled',
  Overlap = 'Overlap',
}

export enum LiveClassScheduleSortFields {
  StartTime = 'start_time',
  EndTime = 'end_time',
  Time = 'start_time',
  LastAccessedDate = '@timestamp',
  Instructor = 'instructorNames',
  Version = 'offering_version',
  Language = 'instruction_language',
  AvailableSeats = 'lms_seat_status',
  Status = 'status',
}

export enum LiveClassEnrollmentErrorStates {
  InvalidStatus = 'invalid status',
  ClassNotExist = 'class is not available',
  UnenrollEnrollmentNotExist = 'unenroll: enrollment does not exist',
  EnrollmentNotExist = 'enrollment does not exist',
  ClassStarted = 'class has already started',
  NotLiveClass = 'not a live class',
  NotCustomer = 'not for customer',
  NotInternal = 'is not for internal',
  MissingDates = 'missing a start or end date',
  NotWithInEnrollment = 'not within the enrollment',
  QuotaReachedEnrolled = 'reached for live class enrolled',
  QuotaReachedEnrolledSku = 'live class enrolled per sku has been reached',
  QuotaReachedCompletedSku = 'live class completed per sku has been reached',
  ConflictingEnrollments = 'you have a conflicting offerings',
  ClassFull = 'class is full',
  CannotCancel = 'cancellation period has ended',
  CannotCancelEnrollmentLms = 'not authorized to cancel enrollment from LMS',
  CannotRescheduleSameOffering = 'cannot reschedule to same offering',
  QuotaReachedEnrolledPlusCompletedSku = 'your combined enrolled and completed quota has been reached',
  EnrollmentPeriodEnded = 'enrollment period for this class has ended',
  GeneralError = '',
}

export type LiveClassInstructor = {
  username?: string;
  name?: string;
  user_uuid?: string;
};

export type Instructor = {
  username: string;
  name: string;
};

export type Session = {
  startDate: string;
  endDate: string;
  sessionName?: string;
  instructors?: LiveClassInstructor[];
};

/**
 * Thew new live virtual class representation from ole_offerings
 */
export type LiveVirtualClass = {
  sku?: string;
  status: string;
  lms_max_enrollments?: number;
  duration_days?: number;
  lms_enrollments_count?: number;
  within_enrollment_period?: boolean;
  enrollment_max_end_time?: string;
  start_time: string;
  early_access_start_time?: string;
  access_start_time?: string;
  access_end_time?: string;
  extension_end_time?: string;
  offering_version?: string;
  offering_slug: string;
  instructors?: {
    username: string;
    name: string;
  }[];
  offering_id: string;
  lms_seats_available?: number;
  timezone?: string;
  instruction_language?: string;
  end_time: string;
  offering_code: string;
  offering_name?: string;
  lms_seat_status?: string;
  status_description: string;
  enrollment_end_time: string;
  /**
   * Class UUID on RDB
   */
  class_uuid?: string;
  class_type?: 'standard' | 'non_standard';
  core?: {
    uuid?: string;
  };
  sessions?: Session[];
  entitlement_id?: string;
};

export type EnhancedLiveClassOffering = LiveVirtualClass & {
  instructorNames?: string;
  time?: string;
  selected?: boolean;
};

export type LiveClassOfferingAggregate = EnhancedLiveClassOffering;
